var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCircleArrowLeft2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "#5F5FFF",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 18
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.8977 24.4199C19.6127 24.4199 19.3277 24.3149 19.1027 24.0899L13.8077 18.7949C13.3727 18.3599 13.3727 17.6399 13.8077 17.2049L19.1027 11.9099C19.5377 11.4749 20.2577 11.4749 20.6927 11.9099C21.1277 12.3449 21.1277 13.0649 20.6927 13.4999L16.1927 17.9999L20.6927 22.4999C21.1277 22.9349 21.1277 23.6549 20.6927 24.0899C20.4827 24.3149 20.1977 24.4199 19.8977 24.4199Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleArrowLeft2);
export default __webpack_public_path__ + "static/media/circle-arrow-left2.fa627d7d472a559b6b10f1b062032eb1.svg";
export { ForwardRef as ReactComponent };